import { createRouter, createWebHistory, type RouteMeta } from 'vue-router'
import DashboardLayoutVue from '@/layouts/dashboard.vue';

interface IRouteMeta {
  title: string
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/dashboard/home',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        title: 'Login',
      } as RouteMeta & IRouteMeta,
    },
    {
      path: '/dashboard',
      component: DashboardLayoutVue,
      redirect: '/dashboard/home',
      meta: {
        title: 'Dashboard',
      },
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/dashboard/examples/Home.vue'),
          meta: {
            title: 'Home',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'task',
          name: 'tasks_index',
          component: () => import('@/views/dashboard/examples/tasks/Index.vue'),
          meta: {
            title: 'Tasks',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'visit',
          name: 'visit_index',
          component: () => import('@/views/dashboard/examples/visit/Index.vue'),
          meta: {
            title: 'Visit',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'news',
          name: 'news_index',
          component: () => import('@/views/dashboard/examples/news/Index.vue'),
          meta: {
            title: 'News',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'news/create',
          name: 'news_create',
          component: () => import('@/views/dashboard/examples/news/Create.vue'),
          meta: {
            title: 'Create News',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'news/edit/:id',
          name: 'news_edit',
          component: () => import('@/views/dashboard/examples/news/Edit.vue'),
          meta: {
            title: 'Edit News',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'settings',
          name: 'settings_index',
          component: () => import('@/views/dashboard/examples/settings/Index.vue'),
          meta: {
            title: 'Settings',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'settings/company',
          name: 'settings_company',
          component: () => import('@/views/dashboard/examples/settings/Company.vue'),
          meta: {
            title: 'Company Info',
          } as RouteMeta & IRouteMeta
        },
        {
          path: 'settings/system',
          name: 'settings_system',
          component: () => import('@/views/dashboard/examples/settings/System.vue'),
          meta: {
            title: 'System Config',
          } as RouteMeta & IRouteMeta
        },
            {
              path: 'analytics',
              name: 'analytics_index',
              component: () => import('@/views/dashboard/examples/analytics/Index.vue'),
              meta: {
                title: 'Analytics',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'leads',
              name: 'leads_index',
              component: () => import('@/views/dashboard/examples/leads/Index.vue'),
              meta: {
                title: 'Leads',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'sample-record',
              name: 'sample_record_index',
              component: () => import('@/views/dashboard/examples/sampleRecord/Index.vue'),
              meta: {
                title: 'Sample Record',
              } as RouteMeta & IRouteMeta
            },
            // 页面内容设置（必须在页面管理之前，避免路由冲突）
            {
              path: 'page-content/home-about',
              name: 'page_content_home_about',
              component: () => import('@/views/dashboard/examples/pageContent/Edit.vue'),
              meta: {
                title: 'Home About Us Settings',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'page-content/factory',
              name: 'page_content_factory',
              component: () => import('@/views/dashboard/examples/pageContent/Edit.vue'),
              meta: {
                title: 'Factory Page Settings',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'page-content/company',
              name: 'page_content_company',
              component: () => import('@/views/dashboard/examples/pageContent/Edit.vue'),
              meta: {
                title: 'Company Page Settings',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'page-content/quality',
              name: 'page_content_quality',
              component: () => import('@/views/dashboard/examples/pageContent/Edit.vue'),
              meta: {
                title: 'Quality Page Settings',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'page-content/privacy',
              name: 'page_content_privacy',
              component: () => import('@/views/dashboard/examples/pageContent/Edit.vue'),
              meta: {
                title: 'Privacy Policy Settings',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'page-content/resources',
              name: 'page_content_resources',
              component: () => import('@/views/dashboard/examples/pageContent/Edit.vue'),
              meta: {
                title: 'Resources Page Settings',
              } as RouteMeta & IRouteMeta
            },
            // 页面管理
            {
              path: 'pages',
              name: 'pages_index',
              component: () => import('@/views/dashboard/examples/pages/Index.vue'),
              meta: {
                title: 'Pages',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'pages/edit/:id?',
              name: 'pages_edit',
              component: () => import('@/views/dashboard/examples/pages/Edit.vue'),
              meta: {
                title: 'Edit Page',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            // 文档模板分类
            {
              path: 'doc-template-categories',
              name: 'doc_template_category_index',
              component: () => import('@/views/dashboard/examples/docTemplateCategory/Index.vue'),
              meta: {
                title: 'Doc Template Categories',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'doc-template-categories/edit/:id?',
              name: 'doc_template_category_edit',
              component: () => import('@/views/dashboard/examples/docTemplateCategory/Edit.vue'),
              meta: {
                title: 'Edit Doc Template Category',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            // 文档模板
            {
              path: 'doc-templates',
              name: 'doc_template_index',
              component: () => import('@/views/dashboard/examples/docTemplate/Index.vue'),
              meta: {
                title: 'Doc Templates',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'doc-templates/edit/:id?',
              name: 'doc_template_edit',
              component: () => import('@/views/dashboard/examples/docTemplate/Edit.vue'),
              meta: {
                title: 'Edit Doc Template',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'leads/:id',
              name: 'leads_edit',
              component: () => import('@/views/dashboard/examples/leads/Edit.vue'),
              meta: {
                title: 'Edit Leads',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'department',
              name: 'department_index',
              component: () => import('@/views/dashboard/examples/department/Index.vue'),
              meta: {
                title: 'Department',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'department/create',
              name: 'department_create',
              component: () => import('@/views/dashboard/examples/department/Create.vue'),
              meta: {
                title: 'Create Department',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'department/edit/:id',
              name: 'department_edit',
              component: () => import('@/views/dashboard/examples/department/Edit.vue'),
              meta: {
                title: 'Edit Department',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'employee',
              name: 'employee_index',
              component: () => import('@/views/dashboard/examples/employee/Index.vue'),
              meta: {
                title: 'Employee',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'employee/create',
              name: 'employee_create',
              component: () => import('@/views/dashboard/examples/employee/Create.vue'),
              meta: {
                title: 'Create Employee',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'employee/edit/:id',
              name: 'employee_edit',
              component: () => import('@/views/dashboard/examples/employee/Edit.vue'),
              meta: {
                title: 'Edit Employee',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'employee/permission/:id',
              name: 'employee_permission',
              component: () => import('@/views/dashboard/examples/employee/Permission.vue'),
              meta: {
                title: 'Employee Permission',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'workmail',
              name: 'workmail_index',
              component: () => import('@/views/dashboard/examples/workmail/Index.vue'),
              meta: {
                title: 'WorkMail',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'resource',
              name: 'resource_index',
              component: () => import('@/views/dashboard/examples/resource/Index.vue'),
              meta: {
                title: 'Resource Manager',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'product',
              name: 'product_index',
              component: () => import('@/views/dashboard/examples/product/Index.vue'),
              meta: {
                title: 'Product',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'product-part-number',
              name: 'product_part_number_index',
              component: () => import('@/views/dashboard/examples/productPartNumber/Index.vue'),
              meta: {
                title: 'Product Part Number',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'spec-type',
              name: 'spec_type_index',
              component: () => import('@/views/dashboard/examples/specType/Index.vue'),
              meta: {
                title: 'Spec Type',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'product/create',
              name: 'product_create',
              component: () => import('@/views/dashboard/examples/product/Create.vue'),
              meta: {
                title: 'Create Product',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'product/edit/:id',
              name: 'product_edit',
              component: () => import('@/views/dashboard/examples/product/Edit.vue'),
              meta: {
                title: 'Product Edit',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'featured-product',
              name: 'featured_product_index',
              component: () => import('@/views/dashboard/examples/featured-product/Index.vue'),
              meta: {
                title: 'Featured Products',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'featured-product/create',
              name: 'featured_product_create',
              component: () => import('@/views/dashboard/examples/featured-product/Edit.vue'),
              meta: {
                title: 'Create Featured Product',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'featured-product/edit/:id',
              name: 'featured_product_edit',
              component: () => import('@/views/dashboard/examples/featured-product/Edit.vue'),
              meta: {
                title: 'Edit Featured Product',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'order',
              name: 'order_index',
              component: () => import('@/views/dashboard/examples/order/Index.vue'),
              meta: {
                title: 'Order',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'order/create',
              name: 'order_create',
              component: () => import('@/views/dashboard/examples/order/Edit.vue'),
              meta: {
                title: 'Create Order',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'order/edit/:id',
              name: 'order_edit',
              component: () => import('@/views/dashboard/examples/order/Edit.vue'),
              meta: {
                title: 'Edit Order',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'payment-account',
              name: 'payment_account_index',
              component: () => import('@/views/dashboard/examples/paymentAccount/Index.vue'),
              meta: {
                title: 'Payment Account',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'payment-account/create',
              name: 'payment_account_create',
              component: () => import('@/views/dashboard/examples/paymentAccount/Create.vue'),
              meta: {
                title: 'Create Payment Account',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'payment-account/edit/:id',
              name: 'payment_account_edit',
              component: () => import('@/views/dashboard/examples/paymentAccount/Edit.vue'),
              meta: {
                title: 'Edit Payment Account',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'category',
              name: 'category_index',
              component: () => import('@/views/dashboard/examples/category/Index.vue'),
              meta: {
                title: 'Category',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'category/create',
              name: 'category_create',
              component: () => import('@/views/dashboard/examples/category/Create.vue'),
              meta: {
                title: 'Create Category',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'category/edit/:id',
              name: 'category_edit',
              component: () => import('@/views/dashboard/examples/category/Edit.vue'),
              meta: {
                title: 'Category Edit',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'email',
              name: 'email_index',
              component: () => import('@/views/dashboard/examples/email/Index.vue'),
              meta: {
                title: 'Email Templates',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'email/edit/:id?',
              name: 'email_edit',
              component: () => import('@/views/dashboard/examples/email/Edit.vue'),
              meta: {
                title: 'Email Template Edit',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'sendgrid',
              name: 'sendgrid_index',
              component: () => import('@/views/dashboard/examples/sendgrid/Index.vue'),
              meta: {
                title: 'WorkMail Test',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'banner',
              name: 'banner_index',
              component: () => import('@/views/dashboard/examples/banner/Index.vue'),
              meta: {
                title: 'Banner Management',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'banner/create',
              name: 'banner_create',
              component: () => import('@/views/dashboard/examples/banner/Create.vue'),
              meta: {
                title: 'Create Banner',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'banner/edit/:id',
              name: 'banner_edit',
              component: () => import('@/views/dashboard/examples/banner/Edit.vue'),
              meta: {
                title: 'Edit Banner',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'language',
              name: 'language_index',
              component: () => import('@/views/dashboard/examples/language/Index.vue'),
              meta: {
                title: 'Language Management',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'language/create',
              name: 'language_create',
              component: () => import('@/views/dashboard/examples/language/Edit.vue'),
              meta: {
                title: 'Create Language',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'language/edit/:id',
              name: 'language_edit',
              component: () => import('@/views/dashboard/examples/language/Edit.vue'),
              meta: {
                title: 'Edit Language',
                hidden: true
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'profile',
              name: 'profile',
              component: () => import('@/views/dashboard/profile/Profile.vue'),
              meta: {
                title: 'Profile',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'settings',
              name: 'settings',
              component: () => import('@/views/dashboard/profile/Settings.vue'),
              meta: {
                title: 'Settings',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'mailbox',
              name: 'mailbox',
              component: () => import('@/views/dashboard/mailbox/Index.vue'),
              meta: {
                title: 'MailBox',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'menu',
              name: 'menu_index',
              component: () => import('@/views/dashboard/examples/menu/Index.vue'),
              meta: {
                title: 'Menu Management',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'menu/create',
              name: 'menu_create',
              component: () => import('@/views/dashboard/examples/menu/Edit.vue'),
              meta: {
                title: 'Create Menu',
              } as RouteMeta & IRouteMeta
            },
            {
              path: 'menu/:id',
              name: 'menu_edit',
              component: () => import('@/views/dashboard/examples/menu/Edit.vue'),
              meta: {
                title: 'Edit Menu',
              } as RouteMeta & IRouteMeta
            },
      ],
    },
    {
      path: '/:pathMatch(.*)',
      name: 'not-found',
      component: () => import('@/views/404.vue'),
      meta: {
        title: 'Page Not Found',
      } as RouteMeta & IRouteMeta,
    },
  ]
});

import { useUserStore } from '@/stores/user'

/** 部署后旧缓存引用失效的懒加载 chunk 时，自动硬刷新一次 */
router.onError((error, to) => {
  const msg = String((error as Error)?.message || error || '')
  const isChunkError =
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    /Loading chunk [\w-]+ failed/i.test(msg)

  if (!isChunkError) return

  const key = '__admin_chunk_reload__'
  const last = Number(sessionStorage.getItem(key) || 0)
  if (Date.now() - last < 15000) return
  sessionStorage.setItem(key, String(Date.now()))
  window.location.assign(to.fullPath || window.location.href)
})

router.beforeEach(async (to, from, next) => {
  // 设置页面标题
  document.title = (to.meta.title as string) || 'Dashboard'
  
  // 获取 token
  const token = localStorage.getItem('token')
  const userStore = useUserStore()
  
  // 如果访问登录页，已登录则跳转到首页
  if (to.path === '/login') {
    if (token) {
      next('/dashboard/home')
    } else {
      next()
    }
    return
  }
  
  // 如果访问需要认证的页面（dashboard 下的所有页面）
  if (to.path.startsWith('/dashboard')) {
    // 再次检查 token（可能在退出登录时被清除了）
    const currentToken = localStorage.getItem('token')
    if (!currentToken) {
      // 未登录，跳转到登录页
      next('/login')
      return
    }
    
      // 如果用户信息未加载，则加载用户信息
      if (!userStore.employee) {
      try {
        await userStore.fetchUserInfo()
        // 如果获取用户信息失败（token 无效），会被清除，需要重新检查
        if (!localStorage.getItem('token')) {
          next('/login')
          return
        }
      } catch (error) {
        // 获取用户信息失败，跳转到登录页
        console.error('[路由守卫] 获取用户信息失败:', error)
        next('/login')
        return
      }
    }
    
    // 先允许导航，不阻塞
    next()
    
    // 如果是客服账号，自动设置为在线（后台异步执行，不阻塞导航）
    if ((userStore.employee as any)?.isCustomerService && userStore.employee?.id) {
      Promise.resolve().then(async () => {
        try {
        const { setOnlineStatus } = await import('@/api/customerServiceSeat')
          await setOnlineStatus(userStore.employee!.id, true)
          console.log('[路由守卫] 客服账号已自动设置为在线')
        } catch (error: any) {
          console.warn('[路由守卫] 设置客服在线状态失败:', error.message)
        }
      })
    }
    return
  }
  
  next()
})

export default router
